import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'

interface SearchHit {
  id: string
  code: string
  title: string
  snippet: string
}

export const Route = createFileRoute('/search')({
  beforeLoad: async () => {
    const s = useAuth.getState()
    if (s.loading) await s.load()
    if (!useAuth.getState().user) throw redirect({ to: '/login' })
  },
  component: SearchPage,
})

function SearchPage() {
  const [q, setQ] = useState('')
  const [hits, setHits] = useState<SearchHit[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (q.trim().length < 2) {
      setHits([])
      return
    }
    const handle = window.setTimeout(async () => {
      setLoading(true)
      try {
        const resp = await api<SearchHit[]>(`/api/search/ideas?q=${encodeURIComponent(q.trim())}`)
        setHits(resp)
      } catch {
        setHits([])
      } finally {
        setLoading(false)
      }
    }, 400)
    return () => window.clearTimeout(handle)
  }, [q])

  return (
    <div className="max-w-3xl mx-auto p-8 space-y-4">
      <h1 className="text-xl font-bold text-zinc-900 dark:text-zinc-100">Поиск идей</h1>
      <input
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Введите ключевое слово (минимум 2 символа)…"
        autoFocus
        className="w-full px-3 py-2 border border-zinc-300 dark:border-zinc-600 rounded-md bg-white dark:bg-zinc-900 text-zinc-900 dark:text-zinc-100"
      />
      {loading && <p className="text-sm text-zinc-500">Ищу…</p>}
      <div className="space-y-2">
        {hits.map((h) => (
          <Link
            key={h.id}
            to="/ideas/$id"
            params={{ id: h.id }}
            className="block bg-white dark:bg-zinc-800 border border-zinc-200 dark:border-zinc-700 rounded-md p-3 hover:bg-zinc-50 dark:hover:bg-zinc-700"
          >
            <p className="text-xs font-mono text-zinc-500">{h.code}</p>
            <p className="font-semibold text-zinc-900 dark:text-zinc-100">{h.title}</p>
            <p className="text-xs text-zinc-600 dark:text-zinc-400 mt-1">{h.snippet}</p>
          </Link>
        ))}
        {!loading && q.trim().length >= 2 && hits.length === 0 && (
          <p className="text-sm text-zinc-500">Ничего не найдено</p>
        )}
      </div>
    </div>
  )
}
